"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayoutContext = exports.LayoutProvider = exports.LayoutContext = void 0;
const use_media_1 = require("use-media");
const react_1 = __importDefault(require("react"));
exports.LayoutContext = react_1.default.createContext({
    isWide: false,
    isTall: false
});
exports.LayoutProvider = (props) => {
    const isTall = use_media_1.useMedia({ minHeight: 850 });
    const isWide = use_media_1.useMedia({ minWidth: 650 });
    const flags = react_1.default.useMemo(() => ({
        isTall,
        isWide
    }), [isTall, isWide]);
    return (react_1.default.createElement(exports.LayoutContext.Provider, { value: flags }, props.children));
};
exports.useLayoutContext = () => react_1.default.useContext(exports.LayoutContext);
//# sourceMappingURL=LayoutContext.js.map